import type { AxiosInstance, AxiosResponse } from "axios"
import type { CustomAxiosRequestConfig } from "./interface"

export function setupResponseInterceptor(axiosInstance: AxiosInstance) {

    // Resposta
    axiosInstance.interceptors.response.use(

        // Successo
        (response: AxiosResponse) => {
            const config = response.config as CustomAxiosRequestConfig;

            if (config?.fullResponse) {
                return response;
            }

            return {
                ...response,
                data: response.data?.data
            };
        }
    )
}